type CachedProfileDisplay = {
  name: string;
  profileImageUrl?: string | null;
};

let cachedProfile: CachedProfileDisplay | null = null;
const loadedAvatarUrls = new Set<string>();

export function getCachedProfileDisplay(): CachedProfileDisplay | null {
  return cachedProfile;
}

export function setCachedProfileDisplay(profile: CachedProfileDisplay | null): void {
  cachedProfile = profile;
}

export function isAvatarUrlLoaded(url: string): boolean {
  return loadedAvatarUrls.has(url);
}

export function markAvatarUrlLoaded(url: string): void {
  loadedAvatarUrls.add(url);
}

export function clearProfileDisplayCache(): void {
  cachedProfile = null;
  loadedAvatarUrls.clear();
}
